import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { NzModalService, NzNotificationService } from 'ng-zorro-antd';
import { takeUntil, take } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ProductsService, RootService } from 'src/app/services';
import { removeEmptyQuery, sleep } from 'src/app/helpers';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductAddQuickComponent } from './product-add-quick/product-add-quick.component';
import { ProductAddQuickService } from './product-add-quick/service/product-add-quick.service';
import { AddProductBcDto } from './product-add-quick/DTO/add-product-bc.dto';
import { ModalProductBadgeComponent } from './modal-product-badge/modal-product-badge.component';
import { ModalPassportComponent } from './modal-passport/modal-passport.component';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-products-list',
  templateUrl: './products-list.component.html',
  styleUrls: ['./products-list.component.scss'],
})
export class ProductsListComponent implements OnInit, OnDestroy {
  constructor(
    public productService: ProductsService,
    public rootService: RootService,
    public notification: NzNotificationService,
    public route: ActivatedRoute,
    public router: Router,
    public modalService: NzModalService,
    public productAddQuickService: ProductAddQuickService
  ) { }
  domainScan = environment.scanMKT
  unsubscribe$ = new Subject<void>();
  isAdmin = false;
  // @ts-ignore
  @ViewChild('updateProduct') updateProduct;
  // @ts-ignore
  @ViewChild('deleteFlashProducts') deleteFlashProducts;

  subscriptions: any = [];

  isAllDisplayDataChecked = false;
  isIndeterminate = false;
  total: number;
  loading: Boolean = true;
  page = 1;
  pageSize = 10;
  listOfDisplayData: any[] = [];
  listOfAllData: any[] = [];
  mapOfCheckedId: { [key: string]: boolean } = {};
  ids: any[] = [];
  isShow: Boolean;
  isVisible = false;
  barcode: string;
  productName: string;
  subscriptionId: number;
  infoStatus: number;
  passportId: number;
  status: number;
  managementStatus: number;
  delayTimer: any;
  owner: string;
  tooltip = 'Ẩn hiển thị sản phẩm trên app iCheck\n' +
    'Yêu cầu Tích chọn sản phẩm';
  tooltip1 = 'Hiển thị sản phẩm trên app iCheck Yêu cầu tích chọn sản phẩm';
  tooltip2 = 'Yêu cầu tích chọn sản phẩm';
  tooltip3 = 'Export file excel danh sách tất cả \n' + 'sản phẩm';
  tooltip4 = 'Thêm nhanh sản phẩm từ Business Center';
  tooltip5 = 'Cập nhật sản phẩm nhanh bằng File excel';
  tooltip6 = 'Xoá nhanh 1 danh sách sản phẩm\n';
  managementStatuses: any[] = [];
  data = {
    productName: '',
    barcode: '',
    status: 0,
    infoStatus: 1,
    managementStatus: 0
  };
  data1 = [];
  statuses = [
    { id: 0, label: 'Chưa có thông tin' },
    { id: 1, label: 'Cho quét' },
    { id: 2, label: 'Đã ẩn bởi DNSH' },
    { id: 3, label: 'Không cho quét' },
  ];
  infoStatuses = [
    { id: 5, label: 'Từ chối duyệt' },
    { id: 6, label: 'Tạm duyệt' },
  ];
  eLabelStatus: string;
  eLabelStatuses = [
    { id: 'NOT_CREATED', label: 'Chưa tạo', color: '#FF4D4F' },
    { id: 'PENDING', label: 'Yêu cầu duyệt', color: '#FAAD14' },
    { id: 'APPROVED', label: 'Đã duyệt', color: '#52C41A' },
    { id: 'REJECTED', label: 'Từ chối duyệt', color: '#FF4D4F' },
    { id: 'PENDING_RE_APPROVAL', label: 'Chờ duyệt lại', color: '#1890FF' },
  ];

  /*Check link image error*/
  imageFalse: any[] = [];

  dataDelete = {
    label: 'Xác nhận xóa sản phẩm',
    value: '<p>Bạn có chắc chắn muốn xoá sản phẩm?</p>',
  };

  isLoadingBtn: Boolean = false;

  @ViewChild('addProduct', { static: true }) addProduct;
  @ViewChild('deleteProducts', { static: true }) deleteProducts;
  action: any;

  sortName: string | null = null;
  sortValue: string | null = null;

  user: any;

  openMessage(type: string, title: string, content: any) {
    return this.notification.create(type, title, content, {
      nzPauseOnHover: true,
    });
  }

  clearPosParam() {
    this.router.navigate(['.'], { relativeTo: this.route });
  }
  passports: any = [];
  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params.barcode !== undefined) {
        this.clearPosParam();
        this.barcode = params.barcode;
      }

      this.loadData();
    });
    this.loadDataSubscription();
    this.loadManagementStatus();
    const user = localStorage.getItem('currentUser');
    this.user = JSON.parse(localStorage.getItem('currentUser'));
    // @ts-ignore
    this.isAdmin = JSON.parse(user).isAdmin;
    // @ts-ignore

    this.productService.getPassports({
      page: 1,
      pageSize: 1000,
      status: 1
    }).subscribe(res => {
      if (res && res.code === 1) {
        this.passports = res.data;
      }
    });
  }


  sort(sort: { key: string; value: string }): void {
    this.sortName = sort.key;
    this.sortValue = sort.value;
    this.search();
  }

  loadDataSubscription() {
    this.productService.getAllSubscription2().subscribe((res) => {
      this.subscriptions = res.data;
    });
  }

  currentPageDataChange($event: any[]): void {
    this.listOfDisplayData = $event;
    this.refreshStatus();
  }

  refreshStatus(data?): void {
    this.isAllDisplayDataChecked = this.listOfDisplayData.every(
      (item) => this.mapOfCheckedId[item.productId]
    );
    this.isIndeterminate =
      this.listOfDisplayData.some(
        (item) => this.mapOfCheckedId[item.productId]
      ) && !this.isAllDisplayDataChecked;
    this.ids = [];
    for (const [key, value] of Object.entries(this.mapOfCheckedId)) {
      if (value) {
        this.ids.push(key);
      }
    }
    if (this.ids.length > 0) {
      this.isShow = false;
    } else {
      this.isShow = true;
    }

    if (data) {
      this.data = {
        productName: data.productName, infoStatus: data.infoStatus,
        status: data.status, managementStatus: data.managementStatus, barcode: data.barcode
      };
      const index = this.data1.findIndex(z => z.barcode === this.data.barcode);
      if (index === -1) {
        this.data1.push(this.data);
        console.log(this.data1);
        return;
      }
      this.data1.splice(index, 1);
      console.log(this.data1);

    }
  }

  checkAll(value: boolean): void {
    this.listOfDisplayData.forEach(
      (item) => (this.mapOfCheckedId[item.productId] = value)
    );
    if (this.data1.length === this.listOfDisplayData.length) {
      this.data1 = [];
      this.isShow = true;
      return;
    }
    this.data1 = this.listOfDisplayData.map(data => {
      return {
        productName: data.productName, infoStatus: data.infoStatus,
        status: data.status, managementStatus: data.managementStatus, barcode: data.barcode
      };
    });
    console.log(this.data1);
    this.refreshStatus();
  }
  async search() {
    await this.loadData();

  }

  filterSubscriptions($event: number) {
    this.subscriptionId = $event;
    this.page = 1;
    this.loadData();
  }

  loadManagementStatus() {
    this.productService
      .getAllManagementStatus()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          if (res.code === 1) {
            this.managementStatuses = res.data;
          }
        },
        (err) => {
          this.openMessage('error', 'Lỗi !!!', `${err}`);
          return;
        }
      );
  }

  filterManagementStatus($event: any) {
    this.managementStatus = $event;
    this.page = 1;
    this.loadData();
  }

  filterStatus($event: any) {
    this.status = $event;
    this.page = 1;
    this.loadData();
  }

  filterInfoStatus($event: any) {
    this.infoStatus = $event;
    this.page = 1;
    this.loadData();
  }

  filterPassportId($event: any) {
    this.passportId = $event;
    this.page = 1;
    this.loadData();
  }

  filterELabelStatus($event: any) {
    this.eLabelStatus = $event;
    this.page = 1;
    this.loadData();
  }

  async loadData(ms = 0) {
    const query: any = {
      product_name: this.productName ? this.productName.trim() : null,
      barcode: this.barcode ? this.barcode.trim() : null,
      subscription_id: this.subscriptionId ? this.subscriptionId : null,
      owner: this.owner ? this.owner : null,
      management_status: this.managementStatus,
      status: this.status,
      info_status: this.infoStatus,
      passportId: this.passportId,
      elabel_status: this.eLabelStatus,
      page: this.page,
      page_size: this.pageSize,
    };
    this.data1 = [];
    removeEmptyQuery(query);
    this.loading = true;
    this.productService
      .getAll(query)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          this.loading = false;
          this.total = res.data.totalElement;
          if (this.sortName && this.sortValue) {
            this.listOfAllData = res.data.items.sort((a, b) =>
              this.sortValue === 'ascend'
                ? a[this.sortName!] > b[this.sortName!]
                  ? 1
                  : -1
                : b[this.sortName!] > a[this.sortName!]
                  ? 1
                  : -1
            );
          } else {
            this.listOfAllData = res.data.items;
          }
          this.listOfAllData = this.listOfAllData.map(item => {
            return {
              ...item,
              eLabelStatus: item.elabel ? item.elabel.status : null,
              eLabelScanCount: item.elabel ? item.elabel.scanCount : 0,
              eLabelQrUrl: item.elabel ? item.elabel.qrUrl : null,
              eLabelRejectReason: item.elabel ? item.elabel.rejectReason : null,
              eLabelHasWarning: item.elabel ? item.elabel.hasWarning : false,
              passports: item.passports && item.passports.length ?
                item.passports.filter(p => p.status === 1).sort((a, b) => b.passportLevel - a.passportLevel) : []
            };
          });

          // console.log("this.listOfAllData", this.listOfAllData)
        },
        (err) => {
          this.openMessage('error', 'Lỗi !!!', `${err}`);
          return;
        }
      );
  }

  detailClick(data) {
    localStorage.setItem('barcode', data.barcode);
    // const value = {productName: data.productName ,  infoStatus: data.infoStatus,
    //   status: data.status, managementStatus: data.managementStatus, barcode: data.barcode};
  }

  resetData() {
    this.barcode = null;
    this.productName = null;
    this.subscriptionId = null;
    this.infoStatus = null;
    this.owner = null;
    this.status = null;
    this.managementStatus = null;
    this.passportId = null;
    this.eLabelStatus = null;
    this.page = 1;
    this.loadData();
  }

  checkImageErr(imageError: any) {
    this.imageFalse.push(imageError);
  }

  showImage(id: any, imageLink: any) {
    if (!this.imageFalse.includes(id)) {
      window.open(imageLink, '_blank');
    }
  }

  previewQRCode(data: any) {
    if (data.eLabelQrUrl) {
      window.open(data.eLabelQrUrl, '_blank');
    }
  }

  copyQRCodeLink(data: any) {
    if (data.eLabelQrUrl) {
      this.copyText(data.eLabelQrUrl);
    }
  }



  deleteQRCode(data: any) {
    this.modalService.confirm({
      nzTitle: 'Xác nhận xóa E-Label',
      nzContent: `Bạn có chắc chắn muốn Xóa e-label? Hành động này không thể hoàn tác.`,
      nzOkText: 'Xóa',
      nzOkType: 'danger',
      nzOnOk: () => {
        this.productService.deleteELabel(data.productId).subscribe(res => {
          if (res.code === 1) {
            this.openMessage('success', 'Thành công', 'Xóa E-Label thành công');
            this.loadData();
          } else {
            this.openMessage('warning', 'Cảnh báo', res.message);
          }
        }, err => {
          this.openMessage('error', 'Lỗi', err.message);
        });
      },
      nzCancelText: 'Hủy'
    });
  }

  delete(id: any) {
    this.productService
      .destroy(id.toString())
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          if (res.code === 1) {
            this.mapOfCheckedId = {};
            this.openMessage(
              'success',
              'Thành công',
              'Xóa sản phẩm thành công'
            );
            this.deleteProducts.handleCancel();

            this.loadData(500);
          }
          if (res.code !== 1) {
            this.openMessage('warning', 'Cảnh báo', `${res.message}`);

          }
          this.deleteProducts.success();
        },
        (err) => {
          this.openMessage('error', 'Lỗi !!!', `${err}`);

          this.deleteProducts.success();
          return;
        }
      );
  }

  hidden(id: any, isHidden: boolean) {

    this.isLoadingBtn = true;
    this.productService
      .hidden(isHidden, id.toString())
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          this.isLoadingBtn = false;
          if (res.code === 1 && isHidden) {
            this.mapOfCheckedId = {};
            this.openMessage('success', 'Thành công', 'Ẩn sản phẩm thành công');
            this.loadData(500);

            return;
          }
          if (res.code === 1 && !isHidden) {
            this.mapOfCheckedId = {};
            this.openMessage(
              'success',
              'Thành công',
              'Hiện sản phẩm thành công'
            );

            this.loadData(500);
            return;
          }
          if (res.code !== 1) {

            this.openMessage('warning', 'Cảnh báo', `${res.message}`);
            return;
          }
        },
        (err) => {

          this.openMessage('error', 'Lỗi !!!', `${err}`);
          this.isLoadingBtn = false;
          return;
        }
      );
  }

  import(data: any) {
    const is_check_gln = data.is_check_gln;
    const is_validate_gtin = data.is_validate_gtin;
    delete data.is_check_gln;
    delete data.is_validate_gtin;
    const formData = new FormData();
    formData.append('file', data.body);
    this.productService
      .importFile(data.subId, formData, is_check_gln, is_validate_gtin)
      .subscribe(
        (res) => {
          this.addProduct.success();
          if (res.code === 1) {
            if (res.data) {
              const arrReason = res.data.filter((data) => {
                if (data.success == false) {
                  return data;
                }
              });
              if (arrReason.length > 0) {
                const barcodes: any[] = [];
                for (const data of arrReason) {
                  barcodes.push(data.barcode);
                }
                this.openMessage(
                  'warning',
                  'Cảnh báo',
                  `<p>Đã tồn tại một yêu cầu quản lý đối với sản phẩm này, vui lòng liên hệ admin để được hỗ trợ</p> <span>Barcode: ${barcodes.join(
                    ', '
                  )}</span>`
                );
              }
              const arrSuccess = res.data.filter((data) => {
                if (data.success) {
                  return data;
                }
              });
              if (arrSuccess.length > 0) {
                const barcodes: any[] = [];
                for (const data of arrSuccess) {
                  barcodes.push(data.barcode);
                }

                this.openMessage(
                  'success',
                  'Thành công',
                  `<p>Import sản phẩm thành công</p> <span>Barcode: ${barcodes.join(
                    ', '
                  )}</span>`
                );
              }
            } else {


              this.openMessage(
                'success',
                'Thành công',
                'Import sản phẩm thành công'
              );
            }
            this.loadData(1000);
            this.addProduct.handleCancel();
            return;
          }
          if (res.code !== 1) {


            this.openMessage('warning', 'Cảnh báo', `${res.message}`);
            return;
          }
        },
        (err) => {


          this.openMessage('error', 'Lỗi !!!', `${err}`);
          this.addProduct.success();
          return;
        }
      );
  }


  addBarcodes(data: any) {
    const body: any = {
      barcodeList: data.barcodes,
      subId: data.subId,
    };
    // new ClickTekoDto('portal_product_list', 'add_new', 'portal_product_create111', {});
    this.productService
      .createV1(body)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          this.addProduct.success();
          if (res.code === 1) {
            if (res.data.onlyOne && res.data.results[0].success) {
              const arrSuccess = res.data.results.filter((data) => {
                if (data.success == true) {
                  return data;
                }
              });
              if (arrSuccess.length > 0) {
                const barcodes: any[] = [];
                for (const data of arrSuccess) {
                  barcodes.push(data.barcode);
                }
                this.openMessage(
                  'success',
                  'Thành công',
                  `<p>Tạo sản phẩm thành công</p> <span>Barcode: ${barcodes.join(
                    ', '
                  )}</span>`
                );
              }

              setTimeout(() => {
                this.router.navigate(['business/products/' + res.data.results[0].id]);
              }, 500);
              return;

            } else {
              const arrReason = res.data.results.filter((data) => {
                if (data.success == false) {
                  return data;
                }
              });
              if (arrReason.length > 0) {
                const barcodes: any[] = [];
                const tmpReason: any = [
                  {
                    message: arrReason[0].reason,
                    barcode: [arrReason[0].barcode],
                  },
                ];
                for (let i = 1; i < arrReason.length; i++) {
                  const gg = arrReason[i];
                  tmpReason.forEach((tmp) => {
                    if (tmp.message == gg.reason) {
                      if (tmp.barcode.indexOf(gg.barcode) == -1) {
                        tmp.barcode.push(gg.barcode);
                      }
                    } else {
                      tmpReason.push({
                        message: gg.reason,
                        barcode: [...gg.barcode],
                      });
                    }
                  });
                }
                for (const data of tmpReason) {
                  // barcodes.push(data.barcode);
                  this.openMessage(
                    'warning',
                    'Cảnh báo',
                    `<p>${data.message
                    }</p> <span><b>Barcode</b>: ${data.barcode.join(', ')}</span>`
                  );
                }
                // this.openMessage('warning', 'Cảnh báo', `<p>${data}</p> <span>Barcode: ${barcodes.join(', ')}</span>`);
              }
              const arrSuccess = res.data.results.filter((data) => {
                if (data.success == true) {
                  return data;
                }
              });
              if (arrSuccess.length > 0) {
                const barcodes: any[] = [];
                for (const data of arrSuccess) {
                  barcodes.push(data.barcode);
                }
                this.openMessage(
                  'success',
                  'Thành công',
                  `<p>Tạo sản phẩm thành công</p> <span>Barcode: ${barcodes.join(
                    ', '
                  )}</span>`
                );
              }
              this.loadData(1000);

              this.addProduct.handleCancel();
              return;
            }
          }
          if (res.code === 1007) {

            this.openMessage('warning', 'Cảnh báo', `Gói đã hết sản phẩm`);
            return;
          }
          if (res.code !== 1) {

            this.openMessage('warning', 'Cảnh báo', `${res.message}`);
            return;
          }
        },
        (err) => {

          this.openMessage('error', 'Lỗi !!!', `${err}`);
          this.addProduct.success();
          return;
        }
      );
  }
  async openModalPassport(productId) {
    await this.router.navigate([`/business/products/passport/${productId}`]);
    // this.modalService.create({
    //   nzTitle : 'Tiêu chuẩn iCheck',
    //   nzContent: ModalPassportComponent,
    //   nzOkText : 'Xác nhận',
    //   nzCancelText : 'Hủy',
    //   nzWidth: '870px',
    //   nzFooter: null,
    //   nzMaskClosable: false,
    //   nzComponentParams: {
    //     urlImageProduct,
    //     productName,
    //     barcodeProduct,
    //     productId,
    //   }
    // });
  }

  openProductBagde(urlImageProduct, productName, barcodeProduct, badges) {
    this.modalService.create({
      nzTitle: 'Huy hiệu sản phẩm đạt được',
      nzContent: ModalProductBadgeComponent,
      nzOkText: 'Xác nhận',
      nzCancelText: 'Hủy',
      nzFooter: null,
      nzMaskClosable: false,
      nzComponentParams: {
        urlImageProduct,
        productName,
        barcodeProduct,
        badges
      }
    });
  }
  addNewProductQuick() {
    this.modalService.create({
      nzTitle: 'Thêm mới nhanh',
      nzContent: ProductAddQuickComponent,
      nzWidth: '800px',
      nzOkText: 'Xác nhận',
      nzCancelText: 'Hủy',
      nzOnOk: (data: ProductAddQuickComponent) => {
        const { subscriptionId, arrBarCode } = data;
        if (arrBarCode.length === 0) {
          this.openMessage('warning', 'Cảnh báo', `Bạn chưa chọn barcode`);
          return false;
        }
        if (!subscriptionId) {
          this.openMessage('warning', 'Cảnh báo', `Bạn chưa chọn gói`);
          return false;
        }
        const query: AddProductBcDto = {
          barcodeList: arrBarCode,
          subId: subscriptionId
        };
        this.productAddQuickService.addProductBC(query).subscribe(z => {
          this.openMessage('success', 'Thành công ', `Thêm sản phẩm thành công`);
          return true;
        });

      }
    });
  }
  exportExcel() {
    const query: any = {
      export_all: this.ids.length === 0,
      product_name: this.productName ? this.productName.trim() : null,
      barcode: this.barcode ? this.barcode.trim() : null,
      subscription_id: this.subscriptionId ? this.subscriptionId : null,
      management_status: this.managementStatus,
      status: this.status,
      info_status: this.infoStatus,
      ids: this.ids ? this.ids.toString() : null,
    };

    removeEmptyQuery(query);

    this.productService
      .exportExcel(query)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.rootService.export(data, 'Danh sách sản phẩm.xlsx');
      });
  }

  actionsButton() {
    if (this.action == 1) {
      this.addProduct.showModal();
    } else if (this.action == 2) {
      this.deleteProducts.showModal(this.dataDelete, this.ids);
    } else if (this.action == 3) {
      this.hidden(this.ids, true);
    } else if (this.action == 4) {
      this.hidden(this.ids, false);
    } else if (this.action == 5) {
      this.exportExcel();
    }
    this.action = null;
  }
  updateProductFromExcel() {
    this.updateProduct.showModal();
  }
  handleupdateProductFromExcel(event) {
    const formData = new FormData();
    formData.append('file', event.file);
    const query = event.params;
    this.productService
      .updateProductFromExcel(query, formData)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          if (res.code === 1) {
            console.log("res", res);
            this.notification.success(
              'Thành công',
              res.message ? res.message : 'Cập nhật thông tin sản phẩm thành công'
            );
            this.updateProduct.cancelLoadingBtn();
            this.updateProduct.handleCancel();
            this.loadData(1000);
            return;
          }
          this.notification.error('Có lỗi xảy ra', res.message);
          this.updateProduct.cancelLoadingBtn();
        },
        (error) => {
          this.notification.error('Có lỗi xảy ra', error.message);
          this.updateProduct.cancelLoadingBtn();
        }
      );
  }
  deleteFlashProduct() {
    this.deleteFlashProducts.showModal();
  }
  handleDeleteFlashProducts(data) {
    const body = data.value;
    this.productService
      .deleteFlashProductByBarcode({ body })
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          this.deleteFlashProducts.cancelLoading();
          if (res.code === 1) {
            this.notification.success('Thành công', 'Xóa sản phẩm thành công');
            this.deleteFlashProducts.handleCancel();
            this.loadData(500);
            return;
          }
          this.notification.error('Có lỗi xảy ra', res.message);
        },
        (error) => {
          this.notification.error('Có lỗi xảy ra', error.message);
          this.deleteFlashProducts.cancelLoading();
        }
      );
    setTimeout(() => {
      this.deleteFlashProducts.cancelLoading();
    }, 2000);
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  saveAsImage(parent, barcode) {
    const parentElement = parent.qrcElement.nativeElement
      .querySelector('canvas')
      .toDataURL('image/png');

    const blobData = this.convertBase64ToBlob(parentElement);

    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE
      window.navigator.msSaveOrOpenBlob(blobData, 'Qrcode');
    } else { // chrome
      const blob = new Blob([blobData], { type: 'image/png' });
      const url = window.URL.createObjectURL(blob);
      // window.open(url);
      const link = document.createElement('a');
      link.href = url;
      link.download = barcode;
      link.click();
    }

  }

  private convertBase64ToBlob(Base64Image: any) {
    const parts = Base64Image.split(';base64,');
    const imageType = parts[0].split(':')[1];
    const decodedData = window.atob(parts[1]);
    const uInt8Array = new Uint8Array(decodedData.length);
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }
    return new Blob([uInt8Array], { type: imageType });
  }

  copyText(text: string): void {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(() => {
        // console.log('Đã copy vào clipboard:', text);
        // alert('Đã sao chép thành công!');
        this.notification.success('Thông báo', 'Đã sao chép thành công!');
      }).catch(err => {
        console.error('Lỗi khi copy:', err);
      });
    } else {
      // Dự phòng cho trình duyệt cũ
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      // alert('Đã sao chép thành công!');
      this.notification.success('Thông báo', 'Đã sao chép thành công!');
    }
  }

  convertBarcode(barcode: string): string {
    if (!barcode) return ''; // Nếu rỗng thì trả về chuỗi rỗng
    const str = barcode.toString();
    return str.padStart(14, '0'); // Thêm '0' ở đầu cho đủ 14 ký tự
  }
}
